module.exports = __webpack_public_path__ + "img/finder.e11ec9e0.svg";